const contactItems = [
  {
    icon: 'ri-map-pin-2-line',
    label: 'Address',
    value: 'BULEVAR KRALJICE MARIJE 3, LOKAL 8',
  },
  {
    icon: 'ri-building-2-line',
    label: 'City',
    value: 'Kragujevac',
  },
  {
    icon: 'ri-mail-line',
    label: 'Zip Code',
    value: '555221',
  },
  {
    icon: 'ri-flag-line',
    label: 'Country',
    value: 'Serbia',
  },
  {
    icon: 'ri-at-line',
    label: 'Email',
    value: 'info@alfadoo.net',
  },
  {
    icon: 'ri-phone-line',
    label: 'Phone',
    value: '+1 7405549276',
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-emerald-600 mb-3 block">Get In Touch</span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">Contact Us</h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto leading-relaxed">
            Have questions about our products or want to learn more about ALFA DOO? We&apos;d love to hear from you.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Contact Info */}
          <div className="bg-white rounded-3xl p-10 border border-gray-100">
            <h3 className="text-xl font-bold text-gray-900 mb-8">Contact Information</h3>
            <div className="space-y-6">
              {contactItems.map((item) => (
                <div key={item.label} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-50 flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-emerald-600 text-lg`} />
                  </div>
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-0.5">{item.label}</p>
                    <p className="text-gray-800 font-medium text-sm">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Map / Visual */}
          <div className="flex flex-col gap-6">
            <div className="bg-white rounded-3xl overflow-hidden border border-gray-100 h-72">
              <iframe
                title="ALFA DOO Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2897.0!2d20.9114!3d43.9993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4757a5a5a5a5a5a5%3A0x0!2sBulevar%20Kraljice%20Marije%203%2C%20Kragujevac%2C%20Serbia!5e0!3m2!1sen!2srs!4v1700000000000"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            <div className="bg-gradient-to-br from-emerald-500 to-teal-600 rounded-3xl p-8 text-white">
              <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-white/20 mb-5">
                <i className="ri-mail-send-line text-white text-2xl" />
              </div>
              <h4 className="text-xl font-bold mb-2">Send Us an Email</h4>
              <p className="text-white/80 text-sm leading-relaxed mb-4">
                For product inquiries, support, or partnership opportunities, reach out directly to our team.
              </p>
              <p className="text-white font-semibold text-sm tracking-wide">info@alfadoo.net</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
